import { Route, Routes, BrowserRouter as Router } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import MobileHomePage from './pages/MobileHomePage';
import Earn from './pages/Earn';
import Invite from './pages/invite';
import About from './pages/about';
import { AuthProvider, useAuth } from './utils/AuthContext';
import './utils/AxiosConfig';
import { UserProvider } from './utils/UserContext';
import TelegramAnalytics from '@telegram-apps/analytics'
import ConceptAbout from './pages/ConceptAbout';
import ConceptInvite from './pages/ConceptInvite';

TelegramAnalytics.init({
    token: 'eyJhcHBfbmFtZSI6Ikh5ZHJpeF9Cb3RfQW5hbHl0aWNzIiwiYXBwX3VybCI6Imh0dHBzOi8vdC5tZS9IeWRyaXhHZW1zQm90IiwiYXBwX2RvbWFpbiI6Imh0dHBzOi8vd3d3Lmh5ZHJpeGFwcC5tZSJ9!9bKkyxdQ4OSXRHm0r/x2xCDL3M0cP2Q9c+IUbTaxnyg=',
    appName: 'Hydrix_Bot_Analytics',

});


function App() {
  return (

    <Router>
      <AuthProvider>
        <UserProvider>
          {<AppRoutes />}
        </UserProvider>
      </AuthProvider>
    </Router>
  )
};

const AppRoutes = () => {
  const { token } = useAuth();

  return (
      <Routes>
        <Route exact path="/" element={<MobileHomePage />} />   
        <Route exact path="/earn" element={<Earn />} />
        <Route exact path="/invite" element={<Invite />} />
        <Route exact path="/about" element={<About />} />    
      </Routes>
      
  )
};

export default App;
